import api from './axiosInstance';

// ── Read (user-facing) ──────────────────────────────────────────────────────
export const listModelPortfolios = () => api.get('/model-portfolios');

export const getModelPortfolio = (id) => api.get(`/model-portfolios/${id}`);

export const getModelPortfolioPositions = (id, capital) =>
  api.get(`/model-portfolios/${id}/positions`, { params: { capital } });

// Latest IEP for a single symbol (from CSV market collections)
export const getSymbolIep = (symbol) =>
  api.get(`/model-portfolios/price/${encodeURIComponent(symbol)}`);

// Rebalance / activity timeline for a portfolio (grouped by admin save).
export const getModelPortfolioEvents = (id, { limit = 50, includePriceOnly = false } = {}) =>
  api.get(`/model-portfolios/${id}/events`, {
    params: { limit, includePriceOnly },
  });

// ── Admin ───────────────────────────────────────────────────────────────────
export const listAllModelPortfolios = () =>
  api.get('/model-portfolios/admin/all');

export const createModelPortfolio = (body) =>
  api.post('/model-portfolios', body);

export const updateModelPortfolio = (id, body) =>
  api.put(`/model-portfolios/${id}`, body);

export const deleteModelPortfolio = (id, hard = false) =>
  api.delete(`/model-portfolios/${id}`, { params: hard ? { hard: true } : {} });
